"use strict";

require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.set-prototype-of.js");
require("core-js/modules/es.function.bind.js");
require("core-js/modules/es.object.create.js");
require("core-js/modules/es.object.get-prototype-of.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.define-properties.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = wrapper;
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.promise.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.number.constructor.js");
var _react = _interopRequireDefault(require("react"));
var _isPromise = _interopRequireDefault(require("res-extensions/build/isPromise"));
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function wrapper(Component) {
  return /*#__PURE__*/function (_React$Component) {
    function _class(props) {
      var _this;
      _classCallCheck(this, _class);
      _this = _callSuper(this, _class, [props]);
      _defineProperty(_this, "componentDidMount", function () {
        return _this._mounted = true;
      });
      _defineProperty(_this, "componentWillUnmount", function () {
        return _this._mounted = false;
      });
      _defineProperty(_this, "componentDidUpdate", function (prevProps, prevState) {
        if (_this.props.errors && _this.props.errors !== _this.state.errors && _this.props.errors !== prevProps.errors) _this.setState({
          errors: _this.props.errors
        });
        if (_this.props.inputs && _this.props.inputs !== _this.state.inputs && _this.props.inputs !== prevProps.inputs) _this.setState({
          inputs: _this.props.inputs
        });
      });
      _defineProperty(_this, "onChange", function (_ref) {
        var target = _ref.target;
        var id = target.id,
          name = target.name,
          type = target.type;
        var value = type === "file" ? target.files[0] : target.value;
        _this.setState(function (prevState) {
          var inputId = name || id;
          var inputs = _objectSpread({}, prevState.inputs);
          // setNestedValue(inputs, inputId, value);
          (0, _lodash.set)(inputs, inputId, value);

          // Reset the error for this field
          var errors = _objectSpread({}, prevState.errors);
          // setNestedValue(errors, inputId, undefined);
          (0, _lodash.set)(inputs, inputId, value);
          return {
            inputs: inputs,
            errors: errors
          };
        }, function () {
          if (_this.props.onChange) {
            var res = _this.props.onChange(_this.state.inputs, name);
            if ((0, _isPromise["default"])(res)) res.then(function () {
              return _this.setState({
                errors: {}
              });
            })["catch"](_this.onError);
          }
        });
      });
      _defineProperty(_this, "onCancel", function (event) {
        if (event) event.preventDefault();
        _this.setState({
          errors: {},
          inputs: {}
        });
        _this.props.onCancel && _this.props.onCancel();
      });
      _defineProperty(_this, "onSubmit", function (event) {
        if (event && event.preventDefault) {
          event.preventDefault();
        }
        if (_this.props.onSubmit && !_this._isSubmitRunning) {
          _this._isSubmitRunning = true;
          var res = _this.props.onSubmit({
            inputs: _this.state.inputs
          });
          if (res && res.then) {
            return res.then(function () {
              _this._isSubmitRunning = false;
              if (_this.props.clearOnSubmit !== false && _this._mounted) {
                _this.setState({
                  errors: {},
                  inputs: {}
                });
              }
            })["catch"](function (e) {
              _this._isSubmitRunning = false;
              _this.onError(e);
            });
          } else {
            _this._isSubmitRunning = false;
          }
        }
      });
      _defineProperty(_this, "onError", function (event) {
        if (event.name === "ValidationException") {
          _this.setState({
            errors: event.errors
          });
        } else {
          return Promise.reject(event);
        }
      });
      _defineProperty(_this, "setError", function (discoveredErrors) {
        _this.setState({
          errors: discoveredErrors
        });
      });
      _this.state = {
        errors: props.errors || {},
        inputs: props.inputs || {}
      };
      return _this;
    }
    _inherits(_class, _React$Component);
    return _createClass(_class, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          inputs: this.state.inputs,
          errors: this.state.errors,
          onChange: this.onChange,
          onCancel: this.onCancel,
          onSubmit: this.onSubmit,
          setError: this.setError
        }));
      }
    }]);
  }(_react["default"].Component);
}